module.exports = __webpack_public_path__ + "static/relative-faux-webfont-cf76e08a63d99549e6899138ca327763.woff";